import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as MBST from 'mb-components';

interface LoginProps {}

type FormData = {
  email: string;
  password: string;
};

interface LoginError {
  type: string;
  message: string;
}

const LoginPage: React.FC<LoginProps> = () => {
  const {
    loginUser,
    logoutUser,
    isAuthenticated,
    userProfile,
  } = MBST.useAuth0();
  const [isLoading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState<LoginError>();
  const { register, handleSubmit, errors } = useForm<FormData>();

  const loginCallback = (err: any) => {
    if (err) {
      setLoginError({
        type: '',
        message: err.description,
      });
      setLoading(false);
    }
  };

  const onSubmit = (data: any) => {
    setLoading(true);
    loginUser(data.email, data.password, loginCallback);
  };

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <>
      {isAuthenticated() && (
        <>
          {!userProfile && <MBST.LoadingSpinner />}
          {userProfile && (
            <>
              <MBST.Box align={'center'} direction={'column'}>
                <p>you are now logged in as:</p>
                <MBST.Heading>{userProfile.email}</MBST.Heading>
                <MBST.A to={`/manage-groups`}>Manage Groups</MBST.A>
                <br />
                <MBST.Button onClick={handleLogout}>Logout</MBST.Button>
              </MBST.Box>
            </>
          )}
        </>
      )}
      {!isAuthenticated() && (
        <>
          <MBST.Heading>Login</MBST.Heading>

          <form onSubmit={handleSubmit(onSubmit)}>
            <MBST.Box margin={{ bottom: '2' }} direction={'column'}>
              <MBST.TextInput
                type={'text'}
                name={'email'}
                placeholder={'Email'}
                ref={register({
                  required: true,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i,
                    message: 'invalid email address',
                  },
                })}
              />
              <MBST.ErrorMessage error={errors.email} />
            </MBST.Box>
            <MBST.Box margin={{ bottom: '5' }} direction={'column'}>
              <MBST.TextInput
                type={'password'}
                name={'password'}
                placeholder={'Password'}
                ref={register({
                  required: true,
                })}
              />
              <MBST.ErrorMessage error={errors.password} />
              <MBST.ErrorMessage error={loginError} />
            </MBST.Box>
            <MBST.Box align={'center'} justify={'between'}>
              <MBST.Button type={'submit'}>
                {isLoading && (
                  <MBST.LoadingSpinner
                    size="small"
                    colors={{
                      first: 'white',
                      second: 'white',
                    }}
                  />
                )}
                {!isLoading && <>Login</>}
              </MBST.Button>
              <MBST.A to={'/forgotten-password'}>Forgotten Password?</MBST.A>
            </MBST.Box>
          </form>
        </>
      )}
    </>
  );
};

export default LoginPage;
